export default __webpack_public_path__ + "static/media/Path3403.c523158d.svg";